export default {
  Editable: {
    parts: ['preview', 'input'],
    baseStyle: {
      input: {
        color: 'gray.800',
        _focus: {
          boxShadow: 'none',
        },
        _placeholder: {
          color: 'gray.700',
        },
      },
    },
    sizes: {},
    variants: {},
    defaultProps: {},
  },
};
